import React from 'react';
import ReactEcharts from 'echarts-for-react';

const GaugeGrade = (props) => {
  const { title, title2, min, max1, max2, valueActiva, valueDiaria, unit, unit2 } = props;

  var option = {
    series: [
      {
        type: 'gauge',
        center: ['50%', '60%'],
        startAngle: 180,
        endAngle: 0,
        min: min,
        max: max1,
        splitNumber: 1,
        
        progress: {
          show: true,
          overlap: false,
          width: 30
        },
        pointer: {
          show: false
        },
        axisLine: {
          lineStyle: {
            width: 30
          }
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: true,
          distance: 20,
          fontSize: 15,
          formatter: "\n{value}",
          color: "#5470c6",
          fontWeight: "bold"
        },
        anchor: {
          show: false
        },
        detail: {
          valueAnimation: true,
          width: '60%',
          lineHeight: 40,
          borderRadius: 8,
          offsetCenter: [0, '-15%'],
          fontSize: 30,
          fontWeight: 'bolder',
          color: 'inherit'
        },
        data: [
          {
            value: valueActiva,
            name: title + ' (' + unit + ')',
            title: {
              offsetCenter: ['90%', '-140%']
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['90%', '-115%']
            }
          }
        ]
      },
      {
        type: 'gauge',
        center: ['50%', '60%'],
        startAngle: 180,
        endAngle: 0,
        min: min,
        max: max2,
        splitNumber: 1,

        itemStyle: {
        },
        progress: {
          show: true,
          overlap: false,
          width: 30
        },
        pointer: {
          show: false
        },
        axisLine: {
          lineStyle: {
            width: 15
          }
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: true,
          distance: -60,
          fontSize: 15,
          formatter: "\n{value}",
          color: "#91cc75",
          fontWeight: "bold"
        },
        anchor: {
          show: false
        },
        detail: {
          valueAnimation: true,
          width: '60%',
          lineHeight: 40,
          borderRadius: 8,
          offsetCenter: [0, '-15%'],
          fontSize: 30,
          fontWeight: 'bolder',
          color: 'inherit'
        },
        data: [
          {
            value: valueDiaria,
            name: title2 + ' (' + unit2 + ')',
            title: {
              offsetCenter: ['-90%', '-140%']
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['-90%', '-115%']
            }
          }
        ]
      }
    ]
  };

  return (
    <ReactEcharts option={option} opts={{ renderer: 'svg' }} />
  );
};

export default GaugeGrade;